type Props = {
  heading?: string;
  subheading?: string;
  setChartOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onChange: (row: string, val: string) => void;
  rowName: string;
  value: any;
  disabled?: boolean;
};

const NeurologicalRows: React.FC<Props> = ({
  heading,
  subheading,
  setChartOpen,
  onChange,
  rowName,
  value,
  disabled = false,
}) => {
  return (
    <div className="grid gap-2 grid-cols-4 items-center">
      <span className="truncate text-sm text-gray-600 dark:text-dark-gray-100 ">
        {heading || subheading}
      </span>
      <button
        className={[
          'grid place-items-center rounded-md border sm:text-sm text-xs font-small transition duration-150 ease-in-out sm:mr-2 sm:w-24 w-16 h-8 sm:h-10',
          value?.[rowName]?.result === 'normal'
            ? 'bg-primary-600 text-white outline-none  '
            : 'border-gray-300 bg-white border  text-gray-700 dark:bg-dark-gray-800 dark:text-dark-gray-100',
        ].join(' ')}
        type="button"
        onClick={
          value?.[rowName]?.result === 'normal' && setChartOpen
            ? () => setChartOpen(true)
            : () => onChange(rowName, 'normal')
        }
        disabled={disabled}
      >
        Normal
      </button>
      <button
        className={[
          'grid place-items-center rounded-md border sm:text-sm text-xs font-small transition duration-150 ease-in-out sm:mr-2 sm:w-24 w-16 h-8 sm:h-10',
          value?.[rowName]?.result === 'abnormal'
            ? 'bg-red-400 text-white outline-none  '
            : 'border-gray-300 bg-white border  text-gray-700 dark:bg-dark-gray-800 dark:text-dark-gray-100',
        ].join(' ')}
        type="button"
        onClick={
          setChartOpen
            ? () => {
                setChartOpen(true);
                onChange(rowName, 'abnormal');
              }
            : () => onChange(rowName, 'abnormal')
        }
        disabled={disabled}
      >
        Abnormal
      </button>
      <button
        className={[
          'grid place-items-center rounded-md border sm:text-sm text-xs font-small transition duration-150 ease-in-out sm:mr-2 sm:w-24 w-16 h-8 sm:h-10 leading-tight',
          value?.[rowName]?.result === 'not assessed' || !value?.[rowName]?.result
            ? 'bg-accent-500 text-white outline-none  '
            : 'border-gray-300 bg-white border  text-gray-700 dark:bg-dark-gray-800 dark:text-dark-gray-100',
        ].join(' ')}
        type="button"
        onClick={() => onChange(rowName, 'not assessed')}
        disabled={disabled}
      >
        Not <br></br>Assessed
      </button>
    </div>
  );
};

export default NeurologicalRows;
